import React, { Suspense, useEffect, useState } from 'react';
import {
  Typography,
  ContentCards,
  LinkCards,
} from 'br2s-ui-componentlibrary_r2_02';
import GlassCard from '@/components/GlassCard/GlassCard';
import SubscribeImg from '@/assets/overview-subscribe.png';
import CollectDocumentImg from '@/assets/overview-subscribe-collect-document.png';
import CollectDocumentImgLong from '@/assets/overview-subscribe-collect-document-long.png';
import { ANNOUNCEMENT, DATA_API, GET_STARTED } from '../overview-constants';
import './SubscribeApis.scss';
import { HTTPErrorAlertContainer } from 'br2s-ui-common-utils-02';
import { useNavigate } from 'react-router-dom';
import { PAGE_PATH } from '@/utilities/constants/content';
import classNames from 'classnames';
import { removeRepeatingForwardSlashes } from '@/utilities/constants';

const PageLoaderModule = React.lazy(() => import('content/PageLoaderModule'));

const SubscribeApis = () => {
  const [hasAnnouncement, setHasAnnouncement] = useState(false);
  const [isImageTop, setIsImageTop] = useState(
    window.innerWidth <= 1200 && window.innerWidth >= 768,
  );
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      // istanbul ignore next
      setIsImageTop(window.innerWidth <= 1200 && window.innerWidth >= 780);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="subscribe-api-page">
      <div className="header-container">
        <HTTPErrorAlertContainer />
        <div className="container">
          <div className="page-header-container">
            <div>
              <Typography
                type="headline-2"
                weight="bold"
                label="ACRA API Marketplace"
              />
              <Typography
                type="headline-5"
                label="Our API services provide access to real-time business information for the creation of innovative digital solutions to meet your business needs."
              />
            </div>
            <div className="overview-icon">
              <img src={SubscribeImg} alt="subscribe" />
            </div>
          </div>

          <div className="subscribe-glasscard">
            <GlassCard>
              <div
                className={classNames('announcement-container', {
                  'd-none': !hasAnnouncement,
                })}
              >
                <Typography
                  type="headline-4"
                  weight="bold"
                  label={ANNOUNCEMENT.TITLE}
                />
                <Suspense fallback={<></>}>
                  <PageLoaderModule
                    pagePath={PAGE_PATH.ANNOUNCEMENT.SUBSCRIBE_APIS}
                    hasAreaComponents={(count: number) =>
                      setHasAnnouncement(!!count)
                    }
                  />
                </Suspense>
              </div>
              <div className="card-section-container">
                <div>
                  <Typography
                    type="headline-3"
                    weight="bold"
                    label="Data APIs"
                  />
                  <Typography
                    type="subheadline"
                    label="Harness business insights with our extensive range of business entity data."
                  />
                </div>
                <div className="carousel-content">
                  {DATA_API.map((data, index) => (
                    <ContentCards
                      key={`cmp-content-card-${index + 1}`}
                      id={`cmp-content-card-${index + 1}`}
                      icon={data.icon}
                      title={data.title}
                      description={data.description}
                      footerBtn={[
                        {
                          label: 'Subscribe',
                          size: 'medium',
                          type: 'tertiary',
                          onClick: () => navigate(data.path as string),
                        },
                      ]}
                    />
                  ))}
                </div>
              </div>
            </GlassCard>
          </div>
        </div>
      </div>

      <div className="footer-container">
        <div className="container">
          <div className="get-started-container">
            <div>
              <Typography type="headline-3" weight="bold" label="Get started" />
              <Typography
                type="subheadline"
                label="Explore resource materials to kickstart your journey with the ACRA API Marketplace."
              />
            </div>
            <div className="image-link-card-container">
              <div className="collect-document-icon">
                <img
                  src={isImageTop ? CollectDocumentImgLong : CollectDocumentImg}
                  alt="collect-document"
                />
              </div>
              <div className="link-card-content">
                {GET_STARTED.map((data, index) => (
                  <LinkCards
                    key={`cmp-link-cards-${index + 1}`}
                    id={`cmp-link-cards-${index + 1}`}
                    title={data.title}
                    description={data.description}
                    href={removeRepeatingForwardSlashes(data.href)}
                    cardSize="small"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscribeApis;
